import { createContext, useState, useEffect, useCallback } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom'; // 1. Import useNavigate
import api from '../api/axios';

const AuthContext = createContext();

export const AuthProviderWrapper = ({ children }) => {
    // We create a wrapper component so we can use the useNavigate hook
    // which must be a child of <Router>
    return (
        <AuthProvider>
            {children}
        </AuthProvider>
    );
};


const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem('token'));
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); // 2. Initialize the hook

  const logout = useCallback(() => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
    navigate('/login'); // Navigate to login on logout
  }, [navigate]);

  useEffect(() => {
    const initializeAuth = async () => {
      if (token) {
        try {
          // axios interceptor will add Authorization header automatically
          const response = await api.get('/auth/profile');
          setUser(response.data);
        } catch (error) {
          console.error("Invalid token on initial load:", error);
          logout(); // This will clear bad tokens
        }
      }
      setLoading(false);
    };
    initializeAuth();
  }, [token, logout]); // Dependency array is correct

  const login = useCallback(async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    const newToken = response.data.access_token;
    console.log('🔓 Login successful!');
    console.log('📋 Token received:', newToken ? `${newToken.substring(0, 20)}...` : 'EMPTY');
    localStorage.setItem('token', newToken);
    console.log('💾 Token stored in localStorage');
    setToken(newToken); // This triggers the useEffect to fetch user data and re-render App
    navigate('/'); // 3. **THE FIX**: Programmatically navigate to the root dashboard
  }, [navigate]);

  const value = { token, user, login, logout, loading };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};


// We export the context and the wrapper provider
export { AuthContext, AuthProvider };